<app-header></app-header>
<main class="pages">
    <section class="bg-green pt-lg-4">
        <div class="container">
            <div class="row ">
                <div class="col-lg-6 offset-lg-3 text-center">
                    <!-- <nav aria-label="breadcrumb text-center">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a routerLink="">Home</a></li>
                            <li class="breadcrumb-item active" aria-current="page">Unsubscribes</li>
                        </ol>
                    </nav> -->
                    <h1 class="page-hero-title my-5">Unsubscribes</h1>
                </div>
            </div>
        </div>
    </section>
    <div class="section-divider">
        <img class="img-fluid" src="assets/curv.svg" alt="">
    </div>
    <section class="py-lg-5">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <h4 class="font-weight-bold">Under Working</h4>
                </div>
            </div>
        </div>
    </section>
</main>
<app-footer></app-footer>